import React from 'react';
import PropTypes from 'prop-types';
import AcademyConfigProp from '../landing/propTypes/academyConfig';
import TermsProp from '../../commonComponents/propTypes/termsProp';
import BrandingProp from '../../commonComponents/propTypes/brandingProp';
import translate from '../../commonComponents/translate';
import NewsletterForm from '../landing/footer/NewsletterForm';
import SupportSection from '../landing/footer/SupportSection';

function ShopMainFooter({ academyConfig, terms }) {
  return (
    <div className="shop-main-footer">
      <div className="shop-main-logo-newsletter-section">
        {academyConfig && academyConfig.footerLogo && (
          <img
            src={academyConfig.footerLogo}
            alt="logo"
            className="shop-main-footer-logo"
          />
        )}
        <NewsletterForm />
      </div>
      <SupportSection academyConfig={academyConfig} terms={terms} />
      <div className="shop-main-copyright-section">
        <p className="shop-main-copyright-text">
          {`${new Date().getFullYear()} © `}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bravon.io"
          >
            Bravon
          </a>
        </p>
      </div>
    </div>
  );
}

ShopMainFooter.propTypes = {
  t: PropTypes.func.isRequired,
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
  terms: PropTypes.shape(TermsProp.propType),
  branding: PropTypes.shape(BrandingProp.propType).isRequired,
};

ShopMainFooter.defaultProps = {
  terms: null,
};

export default translate(ShopMainFooter);
